"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShoppingCheckoutItem = instanceOfShoppingCheckoutItem;
exports.ShoppingCheckoutItemFromJSON = ShoppingCheckoutItemFromJSON;
exports.ShoppingCheckoutItemFromJSONTyped = ShoppingCheckoutItemFromJSONTyped;
exports.ShoppingCheckoutItemToJSON = ShoppingCheckoutItemToJSON;
exports.ShoppingCheckoutItemToJSONTyped = ShoppingCheckoutItemToJSONTyped;
/**
 * Check if a given object implements the ShoppingCheckoutItem interface.
 */
function instanceOfShoppingCheckoutItem(value) {
    return true;
}
function ShoppingCheckoutItemFromJSON(json) {
    return ShoppingCheckoutItemFromJSONTyped(json, false);
}
function ShoppingCheckoutItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'productNo': json['productNo'] == null ? undefined : json['productNo'],
        'colorNo': json['colorNo'] == null ? undefined : json['colorNo'],
        'color': json['color'] == null ? undefined : json['color'],
        'specNo': json['specNo'] == null ? undefined : json['specNo'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'note': json['note'] == null ? undefined : json['note'],
        'promotionsDiscountNo': json['promotionsDiscountNo'] == null ? undefined : json['promotionsDiscountNo'],
        'originalPrice': json['originalPrice'] == null ? undefined : json['originalPrice'],
        'materialPrice': json['materialPrice'] == null ? undefined : json['materialPrice'],
        'discountValue': json['discountValue'] == null ? undefined : json['discountValue'],
        'discountWay': json['discountWay'] == null ? undefined : json['discountWay'],
        'minQuantity': json['minQuantity'] == null ? undefined : json['minQuantity'],
    };
}
function ShoppingCheckoutItemToJSON(json) {
    return ShoppingCheckoutItemToJSONTyped(json, false);
}
function ShoppingCheckoutItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'productNo': value['productNo'],
        'colorNo': value['colorNo'],
        'color': value['color'],
        'specNo': value['specNo'],
        'quantity': value['quantity'],
        'note': value['note'],
        'promotionsDiscountNo': value['promotionsDiscountNo'],
        'originalPrice': value['originalPrice'],
        'materialPrice': value['materialPrice'],
        'discountValue': value['discountValue'],
        'discountWay': value['discountWay'],
        'minQuantity': value['minQuantity'],
    };
}
